const manager = {};
export default manager;
